// Les `Image` restent référencées : le navigateur garde les images décodées, donc elles s'affichent sans attendre
// et, pour l'écran « injoignable », sans réseau.
const held = new Map<string, HTMLImageElement>();

export const preloadImages = (sources: string[]) => {
  for (const src of sources) {
    if (held.has(src)) continue;
    const image = new Image();
    image.src = src;
    held.set(src, image);
  }
};
